import {  Subscription,Observable,timer} from "rxjs";
import { Injectable } from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,GroupedBarChartObject, GroupedBarChartObjectCollection, KeyValue  } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';


@Injectable()
export class PmIntervalBasedBarchartProvider implements DataProvider {

    widget: Widget;
    config: any;
    objectValueUrl = '/api/propertyvalues/';
    propertiesUrl = '/api/properties/';
    valuesUrl = '/api/values?readMaxAge=-1';
    pointName = "";
    labelConfig: any = undefined;
    private timer;
    private subscription: Subscription;
    private widgetDrawn: boolean = false;
    private defaultInterval = 30;
    private dpName: string = "";
    private dataPointName: string;
    private dataPointUnit: string;
    private dpPropertyNames: string[];

    private groupedProperties: any;
    private propertyGroupNamePair: any[];

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private logger: LogService,
        private dashboardConfig: DashboardConfigManager) {

    }

    //this is to get reduced COV data if required
    getReducedCovData(tData:any){

    }

    getData(w: Widget) {
        this.widget = w;
        this.config = this.widget.getConfig();
        try {
            if (this.config == undefined) {
                this.logger.logWarning("PmIntervalBasedBarchartProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.initializeConfig();
                            this.GetObjectValue();
                        }
                    }, error => {
                        //this code will get executed when base URL path is inccorrect
                        this.logger.logWarning("PmIntervalBasedBarchartProvider", "PmIntervalBasedBarchartProvider can not login to desigo cc.");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.initializeConfig();
                this.GetObjectValue();
            } else {
                this.logger.logWarning("PmIntervalBasedBarchartProvider", "PmIntervalBasedBarchartProvider can not login to desigo cc.");
                this.widget.Draw(null);
            }



        }
        catch (error) {
            this.logger.logError('PmIntervalBasedBarchartProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

    // this will zoom the widget
    zoom(zoomFrom: any, zoomTo: any) {
    }


    private StartTimer(widget: Widget) {
        let interval = 1;
        if (this.config.pollingInterval != undefined)
            interval = this.config.pollingInterval;
        else
            interval = this.defaultInterval;

        var timerintervale = interval * 1000;
        this.timer = timer(timerintervale, timerintervale);
        this.subscription = this.timer.subscribe(t => this.callback(widget));
    }

    callback(widget: Widget) {
        this.getData(widget);
    }
    private initializeConfig() {
        if (this.config.dpPropertyNames)
            this.groupedProperties = this.config.dpPropertyNames;
        if (this.config.dataPointName)
            this.dataPointName = this.config.dataPointName;
        if (this.config.dataPointUnit)
            this.dataPointUnit = this.config.dataPointUnit;
        if (this.config.LabelConfiguration) {
            this.labelConfig = this.config.LabelConfiguration;
        }

        if (this.groupedProperties && this.dataPointName) {
            this.dpPropertyNames = [];
            this.propertyGroupNamePair = [];
            this.groupedProperties.forEach(group => {
                // group.GroupName
                let currentGroupProperties = group.properties.split(',');
                if (currentGroupProperties)
                    currentGroupProperties.forEach(propertyName => {
                        this.dpPropertyNames.push(this.dataPointName + '.' + propertyName)
                        this.propertyGroupNamePair.push({ propertyName: propertyName, groupName: group.GroupName })
                    });
                //this.dpPropertyNames.concat(group.properties.split(','));
            })
        }
        else
            this.widget.Draw(null);

    }
    private GetObjectValue() {

        if (!this.dpPropertyNames) {
            this.widget.Draw(null);
            throw new Error("Invalid point name in URL.");
        }

        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + this.valuesUrl;    
        let propertyid:string ="/" + this.dpPropertyNames[0] ? this.dpPropertyNames[0]:undefined;    
        let propertyUrl: string= baseUrl + this.propertiesUrl + propertyid;     
        let resolutionvalue : any;
         //get token
         let token: any = this.authService.getToken();// window.sessionStorage.getItem("_token");
         let headers: HttpHeaders = new HttpHeaders({"Accept": "application/json","Access-Control-Allow-Origin": "*","Authorization": "Bearer " + token});
         // headers.append("Accept", "application/json");
         // headers.append("Access-Control-Allow-Origin", "*");
         // headers.append("Authorization", "Bearer " + token);
         this.logger.logInfo("PmIntervalBasedBarchartProvider", "Calling WSI API");
         //let requestOptions = new RequestOptions({ headers: headers });
         this.http.post(url, this.dpPropertyNames, { headers: headers, observe: "response"}).subscribe((res:HttpResponse<any>) => {
             this.logger.logInfo("PmIntervalBasedBarchartProvider", "Received response." + res);
             try {
                 if (res===null || res.status < 200 || res.status >= 300) {
                     this.widget.Draw(null);
                     throw new Error("Bad response status: " + res.status);
                 }
                 let onlineValues: any = res.body;//.json();
 
 
 
                 if (onlineValues) {
                     var groupedBars: GroupedBarChartObject[] = [];
                     onlineValues.forEach(onlineValue => {
                         if (onlineValue) {
 
                             if (onlineValue.Value && onlineValue.Value) {
                                 let bar: KeyValue = { Key: onlineValue.PropertyName, Unit: "", Value: onlineValue.Value.Value,Resolution:1 };
 
                                 var group = this.propertyGroupNamePair.find(prop => {
                                     return (prop.propertyName === onlineValue.PropertyName)
                                 });
                                 if (group && group.groupName) {
                                     var barGroup = groupedBars.find(groupedbar => { return (groupedbar.Category == group.groupName) });
                                     
                                     if (barGroup)
                                         barGroup.Values.push({ Key: (barGroup.Values.length + 1).toString(), Unit: this.dataPointUnit, Value: parseFloat(onlineValue.Value.Value),Resolution:1  });
                                     else
                                         groupedBars.push({ Category: group.groupName, Values: [{ Key: "1", Unit: this.dataPointUnit, Value: parseFloat(onlineValue.Value.Value),Resolution:1 }] });
 
                                     // if (barGroup)
                                     //     barGroup.Values.push({ Key: group.groupName+(barGroup.Values.length+1), Unit: "", Value: onlineValue.Value.Value });
                                     // else
                                     //     groupedBars.push({ Category: group.groupName, Values: [{ Key: group.groupName+1, Unit: "", Value: onlineValue.Value.Value }] });
 
                                         
                                     // if (barGroup)
                                     //     barGroup.Values.push(bar);
                                     // else
                                     //     groupedBars.push({ Category: group.groupName, Values: [bar] });
  
                                 }
                             }
                         }
                     });
 
 
 
                     var barchartCollection: GroupedBarChartObjectCollection;
                     let header=(this.labelConfig&&this.labelConfig.LocalizedDescription)?this.labelConfig.LocalizedDescription:"Chart";
                     let xAxis=(this.labelConfig&&this.labelConfig.xAxisLabel)?this.labelConfig.xAxisLabel:"X-Axis";
                     let yAxis=(this.labelConfig&&this.labelConfig.yAxisLabel)?this.labelConfig.yAxisLabel:"Y-Axis";
 
                     barchartCollection = { DataPointName: header, xAxisLabel: xAxis, yAxisLabel: yAxis, ResponseArrayCollection: groupedBars };
                     this.logger.logInfo("PMINtervalBasedBarchartProvider", "processed result:" + JSON.stringify(barchartCollection));
                     if (!this.widgetDrawn) {
                         this.widget.Draw(barchartCollection);
                         this.widgetDrawn = true;
                         this.StartTimer(this.widget);
                     }
                     else
                         this.widget.Update(barchartCollection);
                 }
                 else {
                     this.logger.logError("PmIntervalBasedBarchartProvider", "Error while processing response for point name: " + this.pointName);
                     this.widget.Draw(null);
                 }
             }
             catch (error) {
                 this.logger.logError("PmIntervalBasedBarchartProvider", "Error in response : " + error);
             }
         }, (error) => {
             //TODO:
             // this section of code was part of processError() method
             //because widget and loggerhelper are losing their references , moving code to inline method
             //this needs more investigation and code refactor
             let errMsg: any = (error && error.message) ? error.message : "Server error";
             if (this.logger)
                 this.logger.logError("PmIntervalBasedBarchartProvider", "Error in received from service: " + errMsg);
             if (this.widget)
                 this.widget.Draw(null);
         });
 
 
     }
 

    private processError(error: any) {
        let errMsg: any = error.message || "Server error";

        if (this.logger)
            this.logger.logError("PmIntervalBasedBarchartProvider", errMsg);

        if (this.widget)
            this.widget.Draw(null);
    }
    public ngOnDestroy(): void {
        this.dispose();
    }


    dispose(): void {
        try {
            if (this.subscription)
                this.subscription.unsubscribe();
            if (this.logger)
                this.logger.logInfo("PmIntervalBasedBarchartProvider", "PmIntervalBasedBarchartProvider disposed");
        }
        catch (error) {
            if (this.logger)
                this.logger.logError("PmIntervalBasedBarchartProvider", "Error while dispoing PmIntervalBasedBarchartProvider, " + error);
        }

    }



}



